import { render, staticRenderFns } from "./ApprovePurplePhoneContact.vue?vue&type=template&id=7f40ab68&"
import script from "./ApprovePurplePhoneContact.vue?vue&type=script&lang=js&"
export * from "./ApprovePurplePhoneContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports